import Layout from "@/layouts";
import {i18n} from "@/utils/i18n";

const documentType = {
  path: "/transactionScores",
  component: Layout,
  name: "transactionScores",
  redirect: "/transactionScores/index",
  children: [
    {
      path: "/transactionScores/index",
      component: () => import("@/views/transactionScores/index"),
      name: "transactionScores.index",
      meta: { title: i18n.t(`message.transactionScores`) },
    },
  ],
};

export default documentType;
